import store from '../config/configureStore';
import { getSettings, clearSettings } from './ConfigReducer';
import { clearEvents } from './EventsReducer';
import { clearUnits } from './UnitsReducer';
//import { updateZones } from './ZonesReducer';
import { notify, RESET_NOTIFIER } from './NotifierReducer';
import { clearPermissions } from './PermissionCheckReducer';
import { RESET_THEME } from './ThemeReducer';
import { RESET_EVENT_UNITS } from './EventUnitsReducer';
import { RESET_ZONES } from './ZonesReducer';
import { RESET_PAGING } from './PagingReducer';
import { RESET_DIALOGS } from './DialogsReducer';
import { RESET_DATA_CHANGE } from './DataChangeReducer';
import { RESET_911 } from './E911Reducer';
import { RESET_CODE } from './CodeReducer';
import { RESET_PERSON_SEARCH } from './PersonSearchReducer';
import { RESET_LINEUP_PERSON_SEARCH } from './LineupPersonSearchReducer';
import { RESET_MENU } from './MenuReducer';
import { RESET_DATE_UPDATE } from './DataUpdateReducer';
import { RESET_LINEUP_SEARCH } from './LineupsSearchReducer';
import { RESET_INFORMIX_CODE } from './InformixCodesReducer';
import { getService } from './service';

export const USER_SET_AUTHENTICATED = 'USER/SET_AUTHENTICATED';
export const USER_SET_DATA = 'USER/SET_DATA';
export const USER_SET_USER_UNIT = 'USER/USER_SET_USER_UNIT';
export const USER_SET_USER_UNITS = 'USER/SET_USER_UNITS';
export const USER_CLEAR_DATA = 'USER/USER_CLEAR_DATA';
export const USER_SET_PERMISSION = 'USER/USER_SET_PERMISSION';
let logOutSent = false;

export const submitLoginForm = (username, password) => {
  const client = store.store.getState().websocket.websocket;
  return async (dispatch) => {
    try {
      const user = await client.authenticate({
        type: 'pic',
        strategy: 'local',
        username: username,
        password: password,
      });
      logOutSent = false;
      dispatch({ type: USER_SET_DATA, payload: user });
      dispatch({ type: USER_SET_AUTHENTICATED, payload: true });
      dispatch(getSettings());
      //dispatch(updateZones());
    } catch (error) {
      const { code } = error;
      switch (code) {
        case 408:
          dispatch(
            notify(
              'It takes too long to connect to the server. Please check your connection and try again.',
              'warning'
            )
          );
          break;
        case 401:
          dispatch(notify('Login failed. Please try again.', 'error'));
          break;
        default:
          dispatch(
            notify(`Unknown error ${code}. Please check you connection and try again.`, 'error')
          );
      }
    }
  };
};

export const setUserAuthenticated = (state) => {
  const client = store.store.getState().websocket.websocket;
  return (dispatch) => {
    if (client) {
      if (state === false) {
        dispatch(logOut());
      } else {
        dispatch({ type: USER_SET_AUTHENTICATED, payload: true });
      }
    }
  };
};

export const logOut = () => async (dispatch, getState) => {
  if (logOutSent) return;
  logOutSent = true;

  try {
    const client = getState().websocket.websocket;
    client && client.logout();
    const resetActions = [
      { type: RESET_PERSON_SEARCH },
      { type: RESET_LINEUP_PERSON_SEARCH },
      { type: RESET_THEME },
      { type: RESET_NOTIFIER },
      { type: RESET_EVENT_UNITS },
      { type: RESET_ZONES },
      { type: RESET_PAGING },
      { type: RESET_DIALOGS },
      { type: RESET_DATA_CHANGE },
      { type: RESET_911 },
      { type: RESET_CODE },
      { type: RESET_MENU },
      { type: RESET_DATE_UPDATE },
      { type: RESET_LINEUP_SEARCH },
      { type: RESET_INFORMIX_CODE },
    ];

    for (const action of resetActions) {
      await dispatch(action);
    }

    await dispatch(clearPermissions());
    await dispatch(clearSettings());
    await dispatch(clearEvents());
    await dispatch(clearUnits());

    await dispatch({ type: USER_CLEAR_DATA });
  } catch (err) {
    console.error('Logout error:', err);
  }
};

export const setUserData = (data) => {
  return (dispatch) => {
    dispatch({ type: USER_SET_DATA, payload: data });
  };
};

// ----------------------- units

export const setUserUnits = (units) => {
  return (dispatch) => {
    dispatch({ type: USER_SET_USER_UNITS, payload: units });
  };
};

export const setUserUnit = (unit) => {
  const client = store.store.getState().websocket.websocket;
  return async (dispatch) => {
    if (unit) {
      dispatch({ type: USER_SET_USER_UNIT, payload: unit });
    } else {
      if (!client) return;
      try {
        const unitID = store.store.getState().user.userUnit.ptsUnitID;
        const unit = await client.service('units').get(unitID);
        dispatch({ type: USER_SET_USER_UNIT, payload: unit[0] });
      } catch (error) {
        console.log('UserReducer/setUserUnit: error: ', error, error.code);
      }
    }
  };
};

export const changePass = (currentPass, newPass) => {
  const service = getService('authenticate');  
  return service.patch(0, { type: 'pic' , currentPass, newPass, AppName: 'PIC' });
};

const defaultState = {
  isAuthenticated: false,
  userData: null,
  permissions: [],
};

export default function reducer(state = defaultState, action) {
  switch (action.type) {
    case USER_SET_AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: action.payload,
      };
    case USER_SET_DATA:
      return {
        ...state,
        userData: action.payload,
      };
    case USER_CLEAR_DATA:
      return defaultState;
    case USER_SET_PERMISSION:
      return {
        ...state,
        userData: {
          ...state.userData,
          user: {
            ...state.userData.user,
            Permissions: JSON.stringify(action.payload),
          },
        },
      };
    default:
      break;
  }
  return state;
}
